import { THEME } from 'styles/themes';

export const colors = THEME.Navbar.colors ?? {};

export const typography = THEME.Navbar.typography ?? {};

export const options = THEME.Navbar.options ?? {};
